export const FP_DISCLAIMER_TEXT = 'Interaction with this chatbot is an acknowledgement that responses are based on ChatGPT and may not always be accurate. Chat responses do not constitute offers and are not legally binding. Please confirm all information with the dealership prior to making any decisions.';

export const FP_PRIVACY_POLICY_LINK = 'https://www.fullpath.com/legal-and-trust/?nav=privacypolicy';

export const GENERIC_ERROR_MESSAGE = 'An error occurred. Please try again later.';
